import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faSave, faCaretRight, faTrashAlt, faFilePdf, faFileWord } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import moment from 'moment';
import Axios from 'axios';
import { Alert, Logout, BaseURL, DConnect, DecryptCAPBUSS, DecryptData, EncryptCAPBUSS, MakeId, PostCAPBUSS, PostOptions, TinVerification } from '../../components/Config';

function BusinessDetails(props) {
    const [registration, setRegistration] = useState(props.registration);
    const [position, setPosition] = useState(props.position);
    const [businessDetails, setBusinessDetails] = useState(props.businessDetails);
    const [tinValid, setTinValid] = useState('');
    const [gpsValid, setGPSValid] = useState('');
    const [save, setSave] = useState(false);
    const [branches, setBranches] = useState(props.branches);
    const [branch, setBranch] = useState({id:0, app_num:props.registration.app_num, branch_name:'', location:'', createdon:new Date(), modifiedon:new Date(), modifiedby:''});
    const [curdistrict, setCurdistrict] = useState([]);
    const [doc1, setDoc1] = useState({document:'', fileUrl:'', ex:''});
    const [counter, setCounter] = useState(500);
    const [modalstatus , setModalStatus] =  useState(false);
    const [dropdowns, setDropdowns] = useState({'bus_sector':[], 'org_age_bracket':[], 'sub_sector':[], 'bus_permit':[], 'bus_type':[], 
    'operation_status':[], 'getp3bus_sector':[], 'getp3bus_sector_1':[], 'getp3bus_sector_2':[], 'getp3bus_sector_3':[], 'regions':[], 
    'districts':[], 'association':[], bus_permit: []});
    useEffect(() => {
        $('#bmenu').show();
        $('#smenu').show();
        props.getProps(props);
        setRegistration(props.registration);
        setBranches(props.branches);

        let businessDetails = props.businessDetails;
        if(businessDetails.bus_name == ''){
            businessDetails.bus_name=props.registration.bus_name;
            businessDetails.address_email=props.registration.bus_email;
            businessDetails.mobile = props.registration.bus_phone;
        }
        setBusinessDetails(businessDetails);
        //if(props.dropdowns.length > 0){
        setDropdowns(props.dropdowns);
        //}
        setRegistration(props.registration);

        checkExisting(props.registration.app_num);

    }, [props.businessDetails,props.dropdowns,props.registration]);

    const clickTrigger = (id) =>{
        $('#'+id).click();
    }


    const filterDistrict = (region) => setCurdistrict(dropdowns.districts.filter(dist => dist.region === region));


    const handleChange = (e) => {
        e.preventDefault();

        const { name, value } = e.target;

        if(name === 'region'){
            filterDistrict(value);
        }

        if ((value.length === 1 && value == ' ') ||(value.length > 1 && value.charAt(0) == ' ')) return;

        // if(['firstname','lastname','othernames'].includes(name) && value.length > 0){
        //     var letters = /^[A-Za-z]+$/;
        //     if(!value.match(letters)) return;
        //  }
         if(['bus_tin'].includes(name) && value.length > 0){
             let alphanumeric = /^[a-zA-Z0-9]+$/;
             if(!value.match(alphanumeric)) return;
         }else if(['bus_name','landmark','getp3sector_other'].includes(name) && value.length > 0){
            let alphanumericspace = /^[a-zA-Z0-9 ]+$/;
            if(!value.match(alphanumericspace)) return;
        }else if(['mobile','phone'].includes(name) && value.length > 0){
            let numeric = /^[0-9]+$/;
            if(!value.match(numeric)) return;
        }else if(['town'].includes(name) && value.length > 0){
            let alphaspace = /^[a-zA-Z ]*$/;
            if(!value.match(alphaspace)) return;
        }  

        if(['org_age_bracket','emp_size_partime'].includes(name) && value < 0){
            setBusinessDetails(prevState => ({ ...prevState, [name]: 0 }));
        }else if(['association','operation_status','emp_size_','bus_type','bus_sector','getp3sector','getp3subsector'].includes(name)){
            if(value != ''){
            setBusinessDetails(prevState => ({ ...prevState, [name]: parseInt(value) }));
            }
            if(['getp3sector'].includes(name)){
                if(value == 4){
                    setBusinessDetails(prevState => ({ ...prevState, ['getp3subsector']: parseInt(value) }));
                }else{
                    setBusinessDetails(prevState => ({ ...prevState, ['getp3subsector']: 0 }));
                }

            }
        }else if(['date_commenced'].includes(name)){
            let orgAge = moment().diff(value, 'years');
            let org_age_bracket = 0; 
            if(orgAge >= 0 && orgAge <= 1){
                org_age_bracket = 1;
            }else if(orgAge >= 2 && orgAge <= 5){
                org_age_bracket = 2;
            }else if(orgAge >= 6 && orgAge <= 9){
                org_age_bracket = 3;
            }else if(orgAge >= 10){
                org_age_bracket = 4;
            }
            setBusinessDetails(prevState => ({ ...prevState, [name]: value, ['org_age_bracket']: org_age_bracket }));
        }else{
            setBusinessDetails(prevState => ({ ...prevState, [name]: value }));
        }
    }

    const fileChange = (e) => {
        e.preventDefault();

        const {name, value} = e.target;

        let reader = new FileReader();
        let file = e.target.files[0];
        let ext = file.name.split('.');
        if(['jpg','jpeg','png','pdf'].includes(ext[ext.length-1])){
            setBusinessDetails(prevState => ({...prevState, [name]:`${registration.app_num}_${name}.${ext[ext.length-1]}`}));

        reader.onloadend = () => {
            let image = {document:file, fileUrl: reader.result, ext:ext[ext.length-1]};
            
            if(name === 'inc_certificate'){
                setDoc1(image);
            }
        }

        reader.readAsDataURL(file);
      }
    }

    const handleBranch = (e) => {
        e.preventDefault();

        const { name, value } = e.target;

        setBranch(prevState => ({
            ...prevState, [name]: value
        }));
    };

    const saveBranch = (e) => {
        e.preventDefault();

        branches.push(branch);
        props.handleChange(2, branches);

        hideDialog();
    }

    const deleteBranch = (idx) => {
        let newBranch = [...branches];

        newBranch.splice(idx,1);
        setBranches(newBranch);
        props.handleChange(2, newBranch);
    }

    const hideDialog = () => {
        setModalStatus(false);
        
        setBranch({id:0, app_num:props.registration.app_num, branch_name:'', location:'', createdon:new Date(), modifiedon:new Date(), modifiedby:''});
    }


   

    const validateTin = (e) => {
        const { name, value } = e.target;

        if(value === ''){ return; }

        if(!TinVerification(value)){
            setTinValid('Incorrect tin number...');
        }
    }

    const validateGPS = () => {
        let busdetail = businessDetails
        if(busdetail.gps != null && (busdetail.gps.length  == 11 || busdetail.gps.length  == 12 || busdetail.gps.length  == 13)){
           
            if(busdetail.gps.charAt(2) == '-' && (busdetail.gps.charAt(6) == '-' || busdetail.gps.charAt(7) == '-' || busdetail.gps.charAt(8) == '-')){
                if((/[a-zA-Z0-9]/).test(busdetail.gps.charAt(0)) && (/[a-zA-Z0-9]/).test(busdetail.gps.charAt(1))){
                    if((((/^\d+$/).test(busdetail.gps.substr(3, 3)) && busdetail.gps.substr(3, 3).length == 3) && ((/^\d+$/).test(busdetail.gps.substr(7, 10)) && busdetail.gps.substr(7, 10).length == 4)) ||
                    (((/^\d+$/).test(busdetail.gps.substr(3, 4)) && busdetail.gps.substr(3, 4).length == 4) && (((/^\d+$/).test(busdetail.gps.substr(8, 11))&& busdetail.gps.substr(8, 11).length == 4) || ((/^\d+$/).test(busdetail.gps.substr(8, 12)) && busdetail.gps.substr(8, 12).length == 5))) ||
                    (((/^\d+$/).test(busdetail.gps.substr(3, 5)) && busdetail.gps.substr(3, 5).length == 5) && ((/^\d+$/).test(busdetail.gps.substr(9, 12)) && busdetail.gps.substr(9, 12).length == 4))){
                        setGPSValid('');
                    }else{
                        setGPSValid('Invalid GPS Address');
                        setBusinessDetails(prevState => ({ ...prevState, ['gps']: '' }));
                    }
                }else{
                    setGPSValid('Invalid GPS Address');
                    setBusinessDetails(prevState => ({ ...prevState, ['gps']: '' }));
                }
            }else{
                setGPSValid('Invalid GPS Address');
                setBusinessDetails(prevState => ({ ...prevState, ['gps']: '' }));
            } 
        }else{
            setGPSValid('Invalid GPS Address');
            setBusinessDetails(prevState => ({ ...prevState, ['gps']: '' }));
        }

    }

    const checkExisting = (appnum) => {
        DConnect().get(`business?appnum=${appnum}`).then(res => {
            let resdata = DecryptData(res.data);

            if(resdata.length == 0){
                capBussDetails(registration.reg_code, businessDetails.id);
            }

            if(resdata[0].region !== undefined){
                setCurdistrict(props.dropdowns.districts !== undefined ? props.dropdowns.districts.filter(dist => dist.region === resdata[0].region): []);
            }
        }).catch(error => {
            capBussDetails(registration.reg_code, businessDetails.id);
        }); 
    }

    const capBussDetails = (regcode, busid) => {
        if(regcode === '' || busid > 0){return;}

        let formQuery = { query: `SELECT *  FROM business_details WHERE reg_code='${regcode}'` };
        Axios(PostCAPBUSS(formQuery, 'preg_reg/query')).then(res => {
            let resdata = DecryptCAPBUSS(res.data);

            if(resdata.length > 0){
                let capBusiness = {...businessDetails};
                let business = resdata[0];

                capBusiness.bus_name = business.bus_name;
                capBusiness.bus_tin = business.tin_no;
                // capBusiness.org_age_bracket = business.years_operation;
                capBusiness.bus_type = business.reg_type;
                capBusiness.town = business.town;
                capBusiness.location = business.bus_location;
                capBusiness.gps = business.gps_address;
                capBusiness.address_postal = business.postal_address;
                capBusiness.mobile = business.phone_1;
                capBusiness.phone = business.phone_2;
                capBusiness.address_email = business.email;
                capBusiness.association = business.association;
                // capBusiness.assoc_name = business.assoication_code;
                // capBusiness.other_assoc_name = business.assoication_name;
                capBusiness.bus_sector = business.bus_sector;

                setBusinessDetails(capBusiness);
            
            }
        });
    }

    const submitForm = (e) => {
        e.preventDefault();

        if(businessDetails.inc_certificate == '' || businessDetails.inc_certificate == null){
            Alert({title:'Certificate of Incorporation',message:"Upload Certificate of Incorporation", buttons:[{label:'Ok'}]});
            return;
        }

    let queryData = {
        data: `SELECT * FROM business WHERE bus_tin = '${businessDetails.bus_tin}'`
        };

   Axios(PostOptions("POST", queryData, "registration/squery"))
     .then((res) => {
       let rdata = DecryptData(res.data);
       if(rdata.length > 0){
        if(rdata[0].app_num == businessDetails.app_num){
            rdata = []
        }
       }
       if(rdata.length > 0){
        Alert({title:'Business TIN',message:"The Business Tin provided has already been used in another application...", buttons:[{label:'Ok'}]});
        return;
       }
        props.handleChange(0, businessDetails);

        let total1 = parseInt(businessDetails.emp_size_fulltime_male) + parseInt(businessDetails.emp_size_fulltime_female) + parseInt(businessDetails.emp_size_partime_male) + parseInt(businessDetails.emp_size_partime_female);
        let total2 = parseInt(businessDetails.numofemp_ltage18) + parseInt(businessDetails.numofemp_btwage18and35) + parseInt(businessDetails.numofemp_btwage36and45) + parseInt(businessDetails.numofemp_gte_age46);

        if(total1 == total2){
        businessDetails.app_num = registration.app_num;
        let options = (businessDetails.id == 0) ? PostOptions('POST', businessDetails, 'business')
            : PostOptions('PUT', businessDetails, `business/${businessDetails.id}`);

        Axios(options).then(res => {
            let resdata = DecryptData(res.data);

            let formData1 = new FormData();
            formData1.append('filename', businessDetails.inc_certificate);
            formData1.append('cert', doc1.document);
            Axios.post(`${BaseURL()}v1.0/fileupload`, formData1).then(resp => { });   

            if (resdata.id !== undefined) {
                businessDetails['id'] = resdata.id;
                props.handleChange(0, businessDetails);
            }

            position.app_num = registration.app_num;
            position.ma_stage = position.ma_stage < 2 ? 2: position.ma_stage;
            props.handleChange(14, position);
            options = (position.id == 0) ? PostOptions('POST', position, 'appstage')
            : PostOptions('PUT', position, `appstage/${position.id}`);
            Axios(options).then(resD => {
                let resData = DecryptData(resD.data); 

                if (resData.id !== undefined) {
                    position['id'] = resData.id;
                    props.handleChange(14, position);
                }
             })

            props.handleChange(2, branches);
            
            if(branches.length>0){
                Axios(PostOptions('POST', branches, 'branch/bulk')).then(res => {
                    let resdata = DecryptData(res.data);
                    
                    if(resdata.length > 0){
                        props.handleChange(2, resdata);
                    }
                    
                }).catch(error => { Alert({title:'Saving Branches',message:error.message, buttons:[{label:'Ok'}]}); });
            }
            }).catch(error => { Alert({title:'Saving Business Details',message:error.message, buttons:[{label:'Ok'}]}); });
        
            if(save){
            Logout()
            window.location.reload()
            }else{
            props.doNavigate(props,2,1);
            }
      }else{
          alert("To proceed, Employee size disaggregated by gender must be equal to the employee size disaggregated by age...")
      }
    })
}

    return (
        <div className="content">
            <h5>Business <span>Details</span></h5><br />
            <form id="frmBusinessDetails" method="POST" onSubmit={submitForm}>
                <div className="row">
                    <div className="col-xs-12 col-sm-6 ">
                    <div className="form-group">
                            <label className="control-label" for="bus_name" >Registered Business Name:</label><span className="required">*</span>
                            <input type="text" className="form-control" id="bus_name" name="bus_name" required="required" 
                                value={businessDetails.bus_name} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label className="control-label" for="bus_tin">Business TIN :</label><span className="required">*</span>
                            <input type="text" className="form-control" id="bus_tin" name="bus_tin" required="required" 
                                value={businessDetails.bus_tin} onChange={handleChange} onBlur={validateTin} maxLength="11" />
                            <small className="text-warning">{tinValid}</small>
                        </div>
                        <div className="form-group">
                            <label className="control-label" for="date_registered"> Business Registration Date:</label><span className="required">*</span>
                            <input type="date" className="form-control" max={new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0]} id="date_registered" name="date_registered" required="required"
                                value={businessDetails.date_registered} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label className="control-label" for="date_commenced"> Business Commencement Date:</label><span className="required">*</span>
                            <input type="date" className="form-control" max={new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0]} id="date_commenced" name="date_commenced" required="required"
                                value={businessDetails.date_commenced} onChange={handleChange} />
                        </div>
                        
                    </div>
                    <div className="col-xs-12 col-sm-6">
                    
                        <div className="form-group">
                            <label className="control-label" for="operation_status">Are you currently operating or shut down :</label><span className="required">*</span>
                            <select className="form-control custom-select" id="operation_status" name="operation_status" required="required"
                                value={businessDetails.operation_status} onChange={handleChange}>
                                <option value=""> -- Choose Option -- </option>
                                {dropdowns.operation_status.map(optype => (
                                    <option value={optype.ivalue}>{optype.iname} at Date of application</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="control-label" for="bus_type">Type Of Business :</label><span className="required">*</span>
                            <select className="form-control custom-select" id="bus_type" name="bus_type" required="required"
                                value={businessDetails.bus_type} onChange={handleChange}>
                                <option value=""> -- Choose Option -- </option>
                                {dropdowns.bus_type.map(bustype => (
                                    <option value={bustype.ivalue}>{bustype.iname}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="control-label" for="org_age_bracket">Number of years in operation:</label><span className="required">*</span>
                            <select className="form-control custom-select" id="org_age_bracket" name="org_age_bracket" required="required"
                                value={businessDetails.org_age_bracket} onChange={handleChange} disabled>
                                <option value=""> -- Choose Option -- </option>
                                {dropdowns.org_age_bracket.map(bpermit => (
                                    <option value={bpermit.ivalue}>{bpermit.iname}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                                <label className="control-label" for="corporatebankacc">Does the business have a corporate bank account?</label><span className="required">*</span>
                                <select className="form-control custom-select" id="corporatebankacc" name="corporatebankacc" required="required" 
                                    value={businessDetails.corporatebankacc} onChange={handleChange}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                     </div>
                      </div>
                      <div className="col-12">
                      <div className="form-group">
                            <label for="inc_certificate">Upload Certificate of Incorporation:</label><span className="required">*</span>
                            <br /> <small className="text-primary"></small>
                            <div onClick={() => clickTrigger("inc_certificate")} className="border border-primary text-center p-1" style={{cursor:'pointer',minHeight:'120px'}}>
                            {businessDetails.inc_certificate === '' ? 'Click here to add' : 
                                (![undefined,null].includes(businessDetails.inc_certificate) && (businessDetails.inc_certificate).includes('pdf')) 
                                ? <FontAwesomeIcon icon={faFilePdf} style={{fontSize:'120px'}} />
                                :(![undefined,null].includes(businessDetails.inc_certificate) && (businessDetails.inc_certificate).includes('docx'))
                                ? <FontAwesomeIcon icon={faFileWord} style={{fontSize:'120px'}} />
                                : <img src={(doc1.fileUrl !== '') ? doc1.fileUrl : (businessDetails.inc_certificate !== null) ? `${BaseURL()}static/${businessDetails.inc_certificate}`:``} style={{height:'120px'}} /> }
                            </div>
                            <input type="file" className="form-control" accept=".jpg, .jpeg, .png, .pdf" id="inc_certificate" name="inc_certificate" style={{display:'none'}} 
                            onChange={fileChange} /> 
                            <small className="text-primary">Acceptable upload format: <b>jpeg, jpg, png, or pdf</b></small>   
                        </div>
                      </div>
                      <div className="col-12">
                      <table className="table table-condensed table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Indicator</th>
                                    <th style={{width: '400px'}}>Year - 2022</th>
                                </tr>
                            </thead>
                            <tbody>
                                
                                    <tr>
                                        <td rowSpan="5">A.	Employee size disaggregated by Gender at Date of Application</td>
                                        <td><label className="control-label" for="emp_size_fulltime_male" >Full-time Male:</label><span className="required">*</span>
                            <input type="number" min="0" className="form-control" id="emp_size_fulltime_male" name="emp_size_fulltime_male" required="required" 
                                value={businessDetails.emp_size_fulltime_male} onChange={handleChange} /></td>
                                        
                                    </tr>
                                    <tr>
                                        <td><label className="control-label" for="emp_size_fulltime_female" >Full-time Female:</label><span className="required">*</span>
                            <input type="number" min="0" className="form-control" id="emp_size_fulltime_female" name="emp_size_fulltime_female" required="required" 
                                value={businessDetails.emp_size_fulltime_female} onChange={handleChange} /></td>
                                    </tr>
                                    <tr>
                                        <td><label className="control-label" for="emp_size_partime_male" >Part-time Male:</label><span className="required">*</span>
                            <input type="number" min="0" className="form-control" id="emp_size_partime_male" name="emp_size_partime_male" required="required" 
                                value={businessDetails.emp_size_partime_male} onChange={handleChange} /></td>
                                    </tr>
                                    <tr>
                                        <td><label className="control-label" for="emp_size_partime_female" >Part-time Female:</label><span className="required">*</span>
                            <input type="number" min="0" className="form-control" id="emp_size_partime_female" name="emp_size_partime_female" required="required" 
                                value={businessDetails.emp_size_partime_female} onChange={handleChange} /></td>
                                    </tr>
                                    <tr>
                                        <td><label className="control-label" for="emp_size_partime_female" >Total current employees::</label><span className="required">*</span>
                            <input type="number" min="0" className="form-control" id="total1" name="total1" value={parseInt(businessDetails.emp_size_fulltime_male) + parseInt(businessDetails.emp_size_fulltime_female) + parseInt(businessDetails.emp_size_partime_male) + parseInt(businessDetails.emp_size_partime_female)} readOnly /></td>
                                    </tr>
                                    <tr>
                                        <td rowSpan="5">B.	Age Disaggregation of Employees as at Date of Application: (Please State the number of employees from the above total that fall within the following age categories?)</td>
                                        <td><label className="control-label" for="numofemp_ltage18" >Less than 18 years:</label><span className="required">*</span>
                            <input type="number" min="0" className="form-control" id="numofemp_ltage18" name="numofemp_ltage18" required="required" 
                                value={businessDetails.numofemp_ltage18} onChange={handleChange} /></td>
                                        
                                    </tr>
                                    <tr>
                                        <td><label className="control-label" for="numofemp_btwage18and35" >18 – 35:</label><span className="required">*</span>
                            <input type="number" min="0" className="form-control" id="numofemp_btwage18and35" name="numofemp_btwage18and35" required="required" 
                                value={businessDetails.numofemp_btwage18and35} onChange={handleChange} /></td>
                                    </tr>
                                    <tr>
                                        <td><label className="control-label" for="numofemp_btwage36and45" >36 – 45:</label><span className="required">*</span>
                            <input type="number" min="0" className="form-control" id="numofemp_btwage36and45" name="numofemp_btwage36and45" required="required" 
                                value={businessDetails.numofemp_btwage36and45} onChange={handleChange} /></td>
                                    </tr>
                                    <tr>
                                        <td><label className="control-label" for="numofemp_gte_age46" >46 years and above:</label><span className="required">*</span>
                            <input type="number" min="0" className="form-control" id="numofemp_gte_age46" name="numofemp_gte_age46" required="required" 
                                value={businessDetails.numofemp_gte_age46} onChange={handleChange} /></td>
                                    </tr>
                                    <tr>
                                        <td><label className="control-label" for="emp_size_partime_female" >Total current employees::</label><span className="required">*</span>
                            <input type="number" min="0" className="form-control" id="total2" name="total2" value={parseInt(businessDetails.numofemp_ltage18) + parseInt(businessDetails.numofemp_btwage18and35) + parseInt(businessDetails.numofemp_btwage36and45) + parseInt(businessDetails.numofemp_gte_age46)} readOnly /></td>
                                    </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-12">
                    <h5>Annual <span>Sales/Turnover</span></h5><br />
                      <table className="table table-condensed table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Annual Sales/Turnover</th>
                                    <th>2019</th>
                                    <th>2020</th>
                                    <th>2021</th>
                                    <th>2022</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr><td>Less than GHS180K</td>
                            <td>
                                <select className="form-control custom-select" id="lt180k2019" name="lt180k2019" required="required" 
                                    value={businessDetails.lt180k2019} onChange={handleChange} disabled={businessDetails.btw180kand7200k2019 == 1 || businessDetails.btw7200kand21600k2019 == 1 || businessDetails.over21600k2019 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            <td>
                                <select className="form-control custom-select" id="lt180k2020" name="lt180k2020" required="required" 
                                    value={businessDetails.lt180k2020} onChange={handleChange} disabled={businessDetails.btw180kand7200k2020 == 1 || businessDetails.btw7200kand21600k2020 == 1 || businessDetails.over21600k2020 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            <td>
                                <select className="form-control custom-select" id="lt180k2021" name="lt180k2021" required="required" 
                                    value={businessDetails.lt180k2021} onChange={handleChange} disabled={businessDetails.btw180kand7200k2021 == 1 || businessDetails.btw7200kand21600k2021 == 1 || businessDetails.over21600k2021 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            <td>
                                <select className="form-control custom-select" id="lt180k2022" name="lt180k2022" required="required" 
                                    value={businessDetails.lt180k2022} onChange={handleChange} disabled={businessDetails.btw180kand7200k2022 == 1 || businessDetails.btw7200kand21600k2022 == 1 || businessDetails.over21600k2022 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            </tr>
                            <tr><td>Over GHS180K and up to GHS7.2M</td>
                            <td>
                                <select className="form-control custom-select" id="btw180kand7200k2019" name="btw180kand7200k2019" required="required" 
                                    value={businessDetails.btw180kand7200k2019} onChange={handleChange} disabled={businessDetails.lt180k2019 == 1 || businessDetails.btw7200kand21600k2019 == 1 || businessDetails.over21600k2019 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            <td>
                                <select className="form-control custom-select" id="btw180kand7200k2020" name="btw180kand7200k2020" required="required" 
                                    value={businessDetails.btw180kand7200k2020} onChange={handleChange} disabled={businessDetails.lt180k2020 == 1 || businessDetails.btw7200kand21600k2020 == 1 || businessDetails.over21600k2020 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            <td>
                                <select className="form-control custom-select" id="btw180kand7200k2021" name="btw180kand7200k2021" required="required" 
                                    value={businessDetails.btw180kand7200k2021} onChange={handleChange} disabled={businessDetails.lt180k2021 == 1 || businessDetails.btw7200kand21600k2021 == 1 || businessDetails.over21600k2021 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            <td>
                                <select className="form-control custom-select" id="btw180kand7200k2022" name="btw180kand7200k2022" required="required" 
                                    value={businessDetails.btw180kand7200k2022} onChange={handleChange} disabled={businessDetails.lt180k2022 == 1 || businessDetails.btw7200kand21600k2022 == 1 || businessDetails.over21600k2022 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            </tr>
                            <tr><td>Over GHS7.2M and up to GHS21.6M</td>
                            <td>
                                <select className="form-control custom-select" id="btw7200kand21600k2019" name="btw7200kand21600k2019" required="required" 
                                    value={businessDetails.btw7200kand21600k2019} onChange={handleChange} disabled={businessDetails.lt180k2019 == 1 || businessDetails.btw180kand7200k2019 == 1 || businessDetails.over21600k2019 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            <td>
                                <select className="form-control custom-select" id="btw7200kand21600k2020" name="btw7200kand21600k2020" required="required" 
                                    value={businessDetails.btw7200kand21600k2020} onChange={handleChange} disabled={businessDetails.lt180k2020 == 1 || businessDetails.btw180kand7200k2020 == 1 || businessDetails.over21600k2020 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            <td>
                                <select className="form-control custom-select" id="btw7200kand21600k2021" name="btw7200kand21600k2021" required="required" 
                                    value={businessDetails.btw7200kand21600k2021} onChange={handleChange} disabled={businessDetails.lt180k2021 == 1 || businessDetails.btw180kand7200k2021 == 1 || businessDetails.over21600k2021 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            <td>
                                <select className="form-control custom-select" id="btw7200kand21600k2022" name="btw7200kand21600k2022" required="required" 
                                    value={businessDetails.btw7200kand21600k2022} onChange={handleChange} disabled={businessDetails.lt180k2022 == 1 || businessDetails.btw180kand7200k2022 == 1 || businessDetails.over21600k2022 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            </tr>
                            <tr><td>Over GHS21.6M</td>
                            <td>
                                <select className="form-control custom-select" id="over21600k2019" name="over21600k2019" required="required" 
                                    value={businessDetails.over21600k2019} onChange={handleChange} disabled={businessDetails.lt180k2019 == 1 || businessDetails.btw180kand7200k2019 == 1 || businessDetails.btw7200kand21600k2019 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            <td>
                                <select className="form-control custom-select" id="over21600k2020" name="over21600k2020" required="required" 
                                    value={businessDetails.over21600k2020} onChange={handleChange} disabled={businessDetails.lt180k2020 == 1 || businessDetails.btw180kand7200k2020 == 1 || businessDetails.btw7200kand21600k2020 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            <td>
                                <select className="form-control custom-select" id="over21600k2021" name="over21600k2021" required="required" 
                                    value={businessDetails.over21600k2021} onChange={handleChange} disabled={businessDetails.lt180k2021 == 1 || businessDetails.btw180kand7200k2021 == 1 || businessDetails.btw7200kand21600k2021 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            <td>
                                <select className="form-control custom-select" id="over21600k2022" name="over21600k2022" required="required" 
                                    value={businessDetails.over21600k2022} onChange={handleChange} disabled={businessDetails.lt180k2022 == 1 || businessDetails.btw180kand7200k2022 == 1 || businessDetails.btw7200kand21600k2022 == 1}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </td>
                            </tr>
                            </tbody>
                            </table>
                    </div>
                      <div className="row">  
                      <div className="col-xs-12 col-sm-6 ">
                        
                        <div className="form-group">
                            <label className="control-label" for="region">Region: </label><span className="required">*</span>
                            <select className="form-control custom-select" id="region" name="region" required 
                                value={businessDetails.region} onChange={handleChange}>
                                <option value=""> -- Choose Region -- </option>
                                {dropdowns.regions.map(region => (
                                    <option value={region.code}>{region.name} ({region.code})</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="control-label" for="district">District:</label><span className="required">*</span>
                            <select className="form-control custom-select" id="district" name="district" required="required" 
                                value={businessDetails.district} onChange={handleChange}>
                                <option value=""> -- Choose District -- </option>
                                {curdistrict.map(curd => (
                                    <option value={curd.id}>{curd.name} ({curd.code})</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="control-label" for="town">Town: </label><span className="required">*</span>
                            <input  type="text" className="form-control" id="town" name="town" required="required" 
                                value={businessDetails.town} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label className="control-label" for="landmark">Nearest Landmark:</label><span className="required">*</span>
                            <input type="text" className="form-control" id="landmark" name="landmark" required="required" 
                                value={businessDetails.landmark} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label className="control-label" for="address_email">Email Address:</label><span className="required">*</span>
                            <input type="email" className="form-control" id="address_email" name="address_email"  
                                value={businessDetails.address_email} onChange={handleChange} readOnly />
                        </div>

                    </div>


                        <div className="col-xs-12 col-sm-6 ">
                        <div className="form-group">
                            <label className="control-label" for="location">Business Location Address:</label><span className="required">*</span>
                            <textarea className="form-control" rows="4" id="location" name="location" required="required" 
                                value={businessDetails.location} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label className="control-label" for="gps">GPS Address:</label><span className="required">*</span>
                            <input type="text" className="form-control" id="gps" name="gps" required="required" 
                                value={businessDetails.gps} onChange={handleChange} onBlur={validateGPS} maxLength="13"/>
                                <small className="text-danger">{gpsValid}</small>
                        </div>
                        <div className="form-group">
                            <label className="control-label" for="address_postal">Postal Address:</label><span className="required"></span>
                            <textarea className="form-control" rows="4" id="address_postal" name="address_postal" 
                                value={businessDetails.address_postal} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label className="control-label" for="mobile">Business Phone:</label><span className="required">*</span>
                            <input type="tel" className="form-control" id="mobile" name="mobile" pattern="[0-9]{10}" title="10 Digits, no alphabets allowed" minLength="10" maxLength="10" required="required" 
                                value={businessDetails.mobile} onChange={handleChange} readOnly />
                        </div>
                        <div className="form-group">
                            <label for="phone">Other Phone:</label>
                            <input type="tel" className="form-control" id="phone" name="phone"
                                value={businessDetails.phone} onChange={handleChange} pattern="[0-9]{10}" title="10 Digits, no alphabets allowed" minLength="0" maxLength="10" />
                        </div>
                        
                        <div className="form-group">
                            <label className="control-label" for="getp3sector">Select your business sector:</label><span className="required">*</span>
                            <select className="form-control custom-select" id="getp3sector" name="getp3sector" required="required"
                                value={businessDetails.getp3sector} onChange={handleChange}>
                                <option value=""> -- Choose Option -- </option>
                                {dropdowns.getp3bus_sector.map(busect => (
                                    <option value={busect.ivalue}>{busect.iname}</option>
                                ))}
                            </select>
                        </div>
                        {businessDetails.getp3sector != '4' && <div className="form-group">
                            <label className="control-label" for="getp3subsector">Select your business sub-sector:</label><span className="required">*</span>
                            <select className="form-control custom-select" id="getp3subsector" name="getp3subsector" required="required"
                                value={businessDetails.getp3subsector} onChange={handleChange}>
                                <option value=""> -- Choose Option -- </option>
                                {Array.isArray(dropdowns[`getp3bus_sector_${businessDetails.getp3sector}`]) && dropdowns[`getp3bus_sector_${businessDetails.getp3sector}`].map(busect => (
                                    <option value={busect.ivalue}>{busect.iname}</option>
                                ))}
                            </select>
                        </div>}
                       
                        {businessDetails.getp3sector == '4' &&
                        <div className="form-group">
                            <label className="control-label" for="getp3sector_other">Other (Specify):</label>
                            <input type="text" className="form-control" id="getp3sector_other" name="getp3sector_other"
                                value={businessDetails.getp3sector_other} onChange={handleChange} />
                        </div>}
                        
                        
                    </div>
                    <>
                    <div className="col-12">
                        <hr />
                        <label>Business Branches</label>
                        <a onClick={() => setModalStatus(true)} className="btn btn-sm btn-primary" style={{float:'right', marginBottom: 6}}>Add Branch</a>
                    </div>
                    <div className="col-12">
                        <table className="table table-condensed table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Branch Name</th>
                                    <th>Location</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {branches.map((bra, idx) => 
                                    <tr>
                                        <td>{bra.branch_name}</td>
                                        <td>{bra.location}</td>
                                        <td><FontAwesomeIcon icon={faTrashAlt} size="lg" className="text-danger"  style={{cursor:'pointer'}} onClick={() => deleteBranch(idx)} /></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div></>
                    
                </div>
            </form>
            {/* <button className="btn btn-bg btn-outline text-white" style={{ padding: '10px 20px', borderRadius: '20px', marginTop: '25px' }} onClick={() => props.doNavigate(props,1,0)}><FontAwesomeIcon icon={faCaretLeft} size="lg" /> &nbsp; Go Back </button> */}
            <button type="submit" form="frmBusinessDetails" className="btn btn-bg btn-outline text-white float-right" style={{ padding: '10px 20px', borderBottomRightRadius: '20px', borderTopRightRadius: '20px', marginTop: '25px' }}>Save &amp; Next &nbsp; <FontAwesomeIcon icon={faCaretRight} size="lg" /></button>
            <button type="submit" form="frmBusinessDetails" onClick={()=>setSave(true)} className="btn btn-bg btn-outline text-white float-right" style={{ padding: '10px 20px', borderBottomLeftRadius: '20px', borderTopLeftRadius: '20px', marginRight: '5px', marginTop: '25px' }}>Save &amp; Close &nbsp; <FontAwesomeIcon icon={faSave} size="lg" /></button>
            
            <div className="clearfix"></div>
            <div className={modalstatus === true ? "modal fade show d-block" : "modal fade"} arial-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">New Branch</h5>
                        </div>
                        <div className="modal-body">
                            <form id="frmBranch" onSubmit={saveBranch}>
                            
                            <label htmlFor="floatingInput">Branch Name</label>
                            <div className="form-floating mb-3">
                                <input type="text" className="form-control" id="branch_name" name="branch_name" placeholder="Branch Name" required 
                                onChange={handleBranch} value={branch.branch_name}/>
                            </div>

                            <label htmlFor="floatingInput">Location</label>
                            <div className="form-floating mb-3">
                                <textarea className="form-control" id="location" name="location" placeholder="Location" required 
                                onChange={handleBranch} value={branch.location}></textarea>
                            </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" form="frmBranch" className="btn btn-primary">Submit</button>
                            <a onClick={hideDialog} className="btn btn-secondary">Cancel</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BusinessDetails;